export enum CreateModalStep {
    SET_NAME = 'first',
    SET_ACCESS = 'second',
}

export enum ActionType {
    CREATE,
    UPDATE,
    DELETE,
}
